module.exports = __webpack_public_path__ + "img/P.c43bfd7c.png";